export default __webpack_public_path__ + "static/media/video5.8cc65687.mp4";